(function($) {
    class W4D_SidebarCategories {
        constructor() {
            this.sidebar_nav = $('nav[data-current-category-id]');
            this.current_category_id = this.sidebar_nav.attr('data-current-category-id');
            this.active_category = this.sidebar_nav.find(`li[id="side-category-${this.current_category_id}"]`);

            this.initializeActiveCategories();
        }

        initializeActiveCategories() {
            this.active_category.children('.sub-menu').addClass('show');
            this.active_category.children('.toc-toggle').addClass('active');

            this.active_category.parents('li[id^="side-category-"]').each(function() {
                $(this).children('.sub-menu').addClass('show');
                $(this).children('.toc-toggle').addClass('active');
            });
        }
    }

    $(document).ready(() => {
        new W4D_SidebarCategories();
    });

})(jQuery);